/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_AdvancedInputs */

const cs_settings_calendar_advanced = /** @type {(inputs: Settings_Calendar_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokročilé`)
};

const en_settings_calendar_advanced = /** @type {(inputs: Settings_Calendar_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced`)
};

/**
* | output |
* | --- |
* | "Advanced" |
*
* @param {Settings_Calendar_AdvancedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_advanced = /** @type {((inputs?: Settings_Calendar_AdvancedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_AdvancedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_advanced(inputs)
	return cs_settings_calendar_advanced(inputs)
});